




/* eslint-disable @typescript-eslint/camelcase */
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  getAppTextListing,
  getAppTextListing_getAppTextListing_edges
} from "../graphql/types/getAppTextListing";

import AppTextModule from "../store/modules/appTextModule";
import ErrorModule from "../store/modules/errorModule";
import LanguageModule from "../store/modules/languageModule";
import QueryAppText from "../graphql/queryAppText";
import { Translation } from "../interfaces/Translation";
import { getAppTextListingVariables } from "../graphql/types/getAppTextListing";
import { getModule } from "vuex-module-decorators";

const appTextStore = getModule(AppTextModule);
const errorStore = getModule(ErrorModule);
const languageStore = getModule(LanguageModule);

@Component({
  apollo: {
    edges: {
      query: QueryAppText.getAppTextListing,
      variables(): getAppTextListingVariables {
        return {
          language: `${this.language}`,
          filter: `[{"name": "${this.name}"}]`
        };
      },
      update(data: getAppTextListing) {
        // The returned value will update
        // the vue property 'edges'
        const result = data?.getAppTextListing?.edges;
        return result;
      },
      fetchPolicy: "cache-and-network",
      error(error) {
        this.onError(error);
      }
    }
  },
  components: {}
})
export default class AppText extends Vue {
  @Prop() private name?: string;
  @Watch("edges") private onAppTextChanged() {
    // update app text in store
    if (this?.edges) {
      for (const edge of this.edges) {
        if (edge.node?.textTranslations) {
          const translations: Translation[] = [];
          for (const textTranslation of edge.node.textTranslations) {
            if (
              textTranslation?.translationKey &&
              textTranslation.translationValue
            ) {
              translations.push({
                key: textTranslation.translationKey,
                value: textTranslation.translationValue
              });
            }
          }
          appTextStore.set(translations);
        }
      }
    }
  }
  // eslint-disable-next-line @typescript-eslint/camelcase
  private edges?: getAppTextListing_getAppTextListing_edges[];

  private get language() {
    return languageStore.language;
  }

  protected onError(errorMessage: string) {
    errorStore.set(errorMessage);
  }
}
